<template>
	<div>
		<my-navBar></my-navBar>
		<div class='pageBox selMode'>
			<div class="toast">
				<div class="line1">响应国家政策，疫情期间需实名观影</div>
				<div class="line2">请确保如实填写身份信息，否则无法进场观影</div>
				<div class="toastNum">请勾选{{$route.query.needSelNum}}个不同的观影人信息</div>
			</div>
			<div class="list">
				<div class="addOneItemBtn" @click="addIdInfo">
					<span>新增常用观影人</span>
				</div>
				<div class="item" v-for='(customerItem,index) in list' @click="clickItem(index)">
					<!-- 多选按钮、勾选模式才显示 -->
					<img :src="customerItem.isSel?selIcon:unSelIcon" class="selIcon"></img>
					<!-- 信息 -->
					<div class="line1">{{customerItem.name}}</div>
					<div class="line2">
						<span class="title">身份证</span>
						<span>{{customerItem.idCard}}</span>
					</div>
					<img src="@/assets/img/idVerify/delete.png" class="cIcon delete" @click="clickDelBtn(index)"></img>
					<img src="@/assets/img/idVerify/edit.png" class="cIcon" @click="editItem(index)"></img>
				</div>
			</div>
			<div class="loadMore" @click="loadMore">加载更多</div>
			<div class="addBtn" @click="commitIdCards">提交</div>
			<div style="clear: both;"></div>
			<!-- 新增观影人弹窗 -->
			<transition name="fade">
				<add-idCard v-if='showAddIdModal' @hideModal='fnHideAddIdModal' @sucSave='sucSaveId' :editObj='prop_addIdModal' />
			</transition>
		</div>
		<my-footer></my-footer>
	</div>
</template>

<script>
	import addIdCard from '@/components/idCards/add-idCard.vue'
	export default {
		data() {
			return {
				selIcon: require('@/assets/img/idVerify/isSel.png'),
				unSelIcon: require('@/assets/img/idVerify/isUnSel.png'),

				needSelNum: 0, // 需要勾选的人数
				showAddIdModal: false, // 展示新增常用观影人弹窗
				prop_addIdModal: { // 传给‘新增身份信息’弹窗的prop【用于编辑身份信息】
					id: '',
					type: 0,
					name: '',
					idCard: '',
					tel: ''
				},
				pageSizeInfo: {
					page: 0,
					size: 10
				},
				list: [
					// {
					//   id:1,
					//   type:0,
					//   name:'刘殿',
					//   idCard:'440582199*******1144',
					//   tel:'1511',
					//   isSel:false
					// }
				]
			}
		},
		components:{
			'add-idCard':addIdCard
		},
		created: function() {
			//观影人列表
			this.axiosIdList();
		},
		methods: {
			axiosIdList: function(page = 0) {
				var that = this;
				that.axios.post('/resUrl/api/customer/listCustomer', {
						token: that.$store.state.userInfo.token,
						group_id: that.$store.state.group_id,
						page: page,
						size: that.pageSizeInfo.size
					})
					.then(function(res) {
						if (res.data.code == 0) {
							var resList = res.data.content.list;
							if (resList.length == 0) {
								that.$message('没有数据')
							}
							var list = page > 0 ? that.list : [];
							for (var i = 0; i < resList.length; i++) {
								var item = {
									id: resList[i].id,
									type: Number(resList[i].type) - 1,
									name: resList[i].real_name,
									idCard: resList[i].id_card_number,
									tel: resList[i].mobile,
									isSel: false
								}
								list.push(item)
							}
							that.list = list;
							that.pageSizeInfo.page = page;
						} 
					})
			},
			loadMore: function() {
				var page = this.pageSizeInfo.page;
				page++;
				this.axiosIdList(page);
			},
			fnHideAddIdModal: function() {
				this.showAddIdModal = false;
			},
			sucSaveId: function() {
				//隐藏弹窗
				this.fnHideAddIdModal();
				//刷新列表
				this.axiosIdList();
			},
			addIdInfo: function() {
				this.showAddIdModal = true;
				this.prop_addIdModal = {};
			},
			clickItem: function(index) {
				var clickItem = this.list[index];
				var query = this.$route.query;
				//勾选模式--买电影票提交身份证
				if (query.isSelMode) {
					var curSelStatus = clickItem.isSel;
					this.list[index].isSel = !curSelStatus;
				}
				//编辑模式
				else {
					this.editItem(index);
				}
			},
			editItem: function(index) {
				var editItem = this.list[index];
				var prop_addIdModal = { // 传给‘新增身份信息’弹窗的prop【用于编辑身份信息】
					id: editItem.id,
					type: editItem.type,
					name: editItem.name,
					idCard: editItem.idCard,
					tel: editItem.tel
				}
				this.showAddIdModal = true;
				this.prop_addIdModal = prop_addIdModal;
			},
			clickDelBtn: function(index) {
				var that = this;
				this.$confirm('是否确认删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.axios.post('/resUrl/api/customer/delete', {
							token: that.$store.state.userInfo.token,
							group_id: that.$store.state.group_id,
							id: that.list[index].id
						})
						.then(function(res) {
							if (res.data.code == 0) {
								that.axiosIdList();
							} 
						})
				})
			},

			checkInfo: function() {
				var selectedNum = 0;
				var list = this.list;
				for (var i = 0; i < list.length; i++) {
					if (list[i].isSel) {
						selectedNum++;
					}
				}
				//勾选人数不够
				if (selectedNum < this.needSelNum) {
					this.$confirm('还缺少勾选' + (this.needSelNum - selectedNum) + '位观影人信息', '提示', {
						confirmButtonText: '确定',
						showClose: false,
						type: 'warning'
					})
					return;
				}
				return true;
			},
			commitIdCards: function() {
				if (!this.checkInfo()) {
					return;
				}
				//校验通过
				var idCards = [];
				var pushNum = 0;
				var list = this.list;
				for (var i = 0; i < list.length; i++) {
					if (list[i].isSel) {
						//数量够了就停止push，不然后台会报错（买1个座位，上传2个身份信息）
						if (pushNum == this.$route.query.needSelNum) {
							break;
						}
						pushNum++;
						//赋值给全局变量
						idCards.push({
							id: list[i].id,
							type: list[i].type,
							name: list[i].name,
							idCard: list[i].idCard,
							tel: list[i].tel
						})
					}
				}
				this.$store.commit('updateIdCards', idCards)
				this.$router.go(-1)
			}
		}
	}
</script>

<style scoped src='@/assets/css/idCards/idList.css'>
</style>
<style scoped src='@/assets/css/my-ani.css'></style>
